export const IMAGES_URL = "https://image.tmdb.org/t/p/original/";

export const BASE_URL = "https://movie-recommendation-ip.herokuapp.com/api/v1";

export const MOVIE_GENRES = {
  action: "ACTION",
  adventure: "ADVENTURE",
  animation: "ANIMATION",
  children: "CHILDREN",
  comedy: "COMEDY",
  crime: "CRIME",
  documentary: "DOCUMENTARY",
  drama: "DRAMA",
  fantasy: "FANTASY",
  filmNoir: "FILM_NOIR",
  horror: "HORROR",
  imax: "IMAX",
  musical: "MUSICAL",
  mystery: "MYSTERY",
  romance: "ROMANCE",
  scifi: "SCI_FI",
  thriller: "THRILLER",
  war: "WAR",
  western: "WESTERN",
};

export const SEARCH_LENGTH = 12;

export const MY_LIST = "MyList";

export const GODFATHER = {
  id: 858,
  name: "The Godfather",
  description:
    "Spanning the years 1945 to 1955, a chronicle of the fictional Italian-American Corleone crime family. When organized crime family patriarch, Vito Corleone barely survives an attempt on his life, his youngest son, Michael steps in to take care of the would-be killers, launching a campaign of bloody revenge.",
  actors: [],
  type: [
    {
      id: 9,
      name: "Crime",
      type: "CRIME",
    },
    {
      id: 7,
      name: "Drama",
      type: "DRAMA",
    },
  ],
  duration: 175,
  director: null,
  writer: null,
  hasCaptions: false,
  releaseDate: "1972-03-13T22:00:00.000+00:00",
  imdbId: 68646,
  posterPath: "/3bhkrj58Vtu7enYsRolD1fZdja1.jpg",
  backdropPath: "/AbgEQO2mneCSOc8CSnOMa8pBS8I.jpg",
  voteAverage: 8.7,
  voteCount: 15968,
  deleted: false,
};

export const DUMB_AND_DUMBER = {
  id: 231,
  name: "Dumb and Dumber",
  description:
    'Lloyd and Harry are two men whose stupidity is really indescribable. When Mary, a beautiful woman, loses an important suitcase with money before she leaves for Aspen, the two friends (who have found the suitcase) decide to return it to her. After some "adventures" they finally get to Aspen where, using the lost money they live it up and fight for Mary\'s heart.',
  actors: [],
  type: [
    {
      id: 1,
      name: "Adventure",
      type: "ADVENTURE",
    },
    {
      id: 4,
      name: "Comedy",
      type: "COMEDY",
    },
  ],
  duration: 107,
  director: null,
  writer: null,
  hasCaptions: false,
  releaseDate: "1994-12-16T00:00:00.000+00:00",
  imdbId: 109686,
  posterPath: "/4LdpBXiCyGKkR8FGHgjKlphrfUc.jpg",
  backdropPath: "/6ELocXlTnboUAxoevKIs9nhfiuS.jpg",
  voteAverage: 6.6,
  voteCount: 5027,
  deleted: false,
};

export const TAXI_DRIVER = {
  id: 111,
  name: "Taxi Driver",
  description:
    "A mentally unstable Vietnam War veteran works as a night-time taxi driver in New York City where the perceived decadence and sleaze feed his urge for violent action, attempting to save a preadolescent prostitute in the process.",
  actors: [],
  type: [
    {
      id: 7,
      name: "Drama",
      type: "DRAMA",
    },
    {
      id: 9,
      name: "Crime",
      type: "CRIME",
    },
    {
      id: 10,
      name: "Thriller",
      type: "THRILLER",
    },
  ],
  duration: 114,
  director: null,
  writer: null,
  hasCaptions: false,
  releaseDate: "1976-02-09T00:00:00.000+00:00",
  imdbId: 75314,
  posterPath: "/ekstpH614fwDX8DUln1a2Opz0N8.jpg",
  backdropPath: "/fhejfyX20tyF0s65CIf27wOuH9G.jpg",
  voteAverage: 8.2,
  voteCount: 9361,
  deleted: false,
};
